<template>
    <div class="container-fluid">
        <br>
        <router-link to="/empresas" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button v-if="auth_user.ambiente === 'A'" type="button" :disabled="loading" @click="saveData()"
            class="btn btn-lg btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <h4 class="text-center">Plano Empresa: <strong>{{form.empresa.empresa_nome}} -
                {{form.empresa.empresa_documento}}</strong>
        </h4>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item" v-if="auth_user.ambiente === 'A'">
                            <a href="#tabFormulario" class="nav-link active" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-wrench"></i>
                                Editar Plano
                            </a>
                        </li>
                        <li role="presentation" class="nav-item" v-if="auth_user.ambiente !== 'A'">
                            <a href="#tabPlano" class="nav-link active" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-tag"></i>
                                Plano
                            </a>
                        </li>
                        <li>
                            <a href="#tabModulos" class="nav-link" aria-controls="tabModulos" role="tab"
                                data-toggle="tab">
                                <i class="glyphicon glyphicon-th-large"></i>
                                Módulos Habilitados
                            </a>
                        </li>
                        <li>
                            <a href="#tabAcessos" class="nav-link" aria-controls="tabAcessos" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-plus"></i>
                                Módulos Adicionais
                            </a>
                        </li>
                        <li>
                            <a href="#tabHistorico" class="nav-link" aria-controls="tabHistorico" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-history"></i>
                                Histórico
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div v-if="auth_user.ambiente === 'A'" role="tabpanel" class="tab-pane active"
                            id="tabFormulario">
                            <tab-plano-form ref="FormPlano" v-bind="form" @updateForm="updateForm"></tab-plano-form>
                        </div>
                        <div v-if="auth_user.ambiente !== 'A'" role="tabpanel" class="tab-pane active" id="tabPlano">
                            <tab-plano :empresa="form.empresa"></tab-plano>
                        </div>
                        <div role="tabpanel" class="tab-pane" id="tabModulos">
                            <tab-modulos :plano="form.empresa.plano"></tab-modulos>
                        </div>
                        <div role="tabpanel" class="tab-pane" id="tabAcessos">
                            <tab-adicionais v-bind="form"></tab-adicionais>
                        </div>
                        <div role="tabpanel" class="tab-pane" id="tabHistorico">
                            <tab-history :empresa="form.empresa"></tab-history>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
</template>

<script>
    import TabModulos from '../../planos/components/tab-modulos.vue';
    import TabAdicionais from './tab-adicionais.vue';
    import TabHistory from './tab-history.vue';
    import TabPlanoForm from './tab-plano-form.vue';
    import TabPlano from './tab-plano.vue';
    export default {
        components: {
            TabModulos,
            TabPlanoForm,
            TabAdicionais,
            TabHistory,
            TabPlano
        },
        data() {
            return {
                loading: false,
                form: {
                    empresa: {
                        empresa_nome: null,
                        empresa_documento: null,
                        plano: {
                            modulos: [],
                            adicionais: [],
                        },
                    },
                    validades: [],
                    planos: []
                }
            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        mounted() {
            this.$store.dispatch('getAllPlanoModulo');
            this.getParametros();
        },
        watch: {
            $route() {
                this.$destroy();
            }
        },
        methods: {
            getParametros() {
                this.$store.dispatch('getEmpresaPlano', this.$route.params.id).then(response => {
                    this.updateForm(response);
                    if (this.auth_user.ambiente === 'A') {
                        this.$refs.FormPlano.selectedPlano = response.planos.find(x => x.id == response.empresa
                            .plano.fk_plano_id);
                    }
                });
            },
            saveData() {
                this.loading = true;
                this.form.empresa.plano.fk_empresa_id = this.$route.params.id;
                this.$store.dispatch('savePlanoEmpresa', this.form.empresa.plano).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                    }
                    console.log(response);
                });
            },
            updateForm(payload) {
                this.form.empresa = payload.empresa;
                this.form.planos = payload.planos;
                this.form.validades = payload.validades;
            }
        }
    }
</script>